import { useEffect } from 'react';
import { MO_TRACK_EVENTS_ERROR } from '../lib/mo-track-events';
import { useErrorTrackUserAnalytics } from '../lib/analytics/error-tracking';
import { buildErrorPayload } from '../lib/amplitude/build-error-payload';

export const ErrorBoundaryTrack = ({ error }) => {
  const [track] = useErrorTrackUserAnalytics();

  useEffect(() => {
    track(MO_TRACK_EVENTS_ERROR.PAGE_CRASH, {
      eventProperties: {
        ...buildErrorPayload(error),
      },
    });
  }, []);

  return null;
};
